// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".place-content>div>p>strong{font-weight:500}.dialog-frame{min-width:300px}.dialog-frame>form>div{display:flex;flex-direction:column;align-items:center}.dialog-frame>form>div>div{display:flex;justify-content:space-around;gap:20px}", ""]);
// Exports
module.exports = exports;
